import humps from 'humps'
import { defineAction } from '_utils/redux'
import * as laborTypeServices from '_services/labor-type'

export const GET_LABOR_TYPES = defineAction('GET_LABOR_TYPES')
export const GET_LABOR_TYPE_BY_ID = defineAction('GET_LABOR_TYPE_BY_ID')
export const POST_LABOR_TYPE = defineAction('POST_LABOR_TYPE')
export const PATCH_LABOR_TYPE = defineAction('PATCH_LABOR_TYPE')

export const getLaborTypes =
  (params = {}) =>
  async (dispatch, getState) => {
    const formattedParams = humps.decamelizeKeys(params)
    const data = await laborTypeServices.getLaborTypes(getState().user.authToken)(formattedParams)
    dispatch({
      type: GET_LABOR_TYPES.ACTION,
      payload: async () => data,
    })
    return data
  }

export const getLaborTypeById = laborTypeId => async (dispatch, getState) => {
  const data = await laborTypeServices.getLaborTypeById(getState().user.authToken)(laborTypeId)
  dispatch({
    type: GET_LABOR_TYPE_BY_ID.ACTION,
    payload: async () => data,
  })
  return data
}

export const postLaborType = payload => async (dispatch, getState) => {
  const formattedPayload = humps.decamelizeKeys(payload)
  const data = await laborTypeServices.postLaborType(getState().user.authToken)(formattedPayload)
  dispatch({
    type: POST_LABOR_TYPE.ACTION,
    payload: async () => data,
  })
  return data
}

export const patchLaborType = (laborTypeId, payload) => async (dispatch, getState) => {
  const formattedPayload = humps.decamelizeKeys(payload)
  const data = await laborTypeServices.patchLaborType(getState().user.authToken)(
    laborTypeId,
    formattedPayload
  )
  dispatch({
    type: PATCH_LABOR_TYPE.ACTION,
    payload: async () => data,
  })
  return data
}
